import React from 'react';

import styled, {css} from 'styled-components';

import {H2} from '../primitives';
import {mixins} from '../styles';
import {ERROR_NODE_HEIGHT} from './constants';

export type TFormFieldProps = {
  noMargin?: boolean;
  isGroupViewType?: boolean;
  name?: string;
  type?: string;
  width?: React.CSSProperties['width'];
};

const getMarginBottom = ({noMargin, isGroupViewType, theme, type}: TTheme & TFormFieldProps) => {
  if (noMargin) {
    return css`
      margin-bottom: 0;
    `;
  }

  if (isGroupViewType) {
    return css`
      margin-bottom: ${theme.spacing.s2};
    `;
  }

  const marginBottom = ERROR_NODE_HEIGHT;

  if (type === 'radio') {
    return css`
      margin-bottom: ${theme.spacing.s2};
      &:last-child {
        margin-bottom: 0;
      }
    `;
  }

  return css`
    margin-bottom: ${marginBottom}px;
    &:last-child {
      margin-bottom: 0;
    }
  `;
};

// @ts-expect-error custom attribute
export const FormField = styled.div.attrs<TFormFieldProps>(({name}) => ({
  'data-field': name,
}))`
  ${mixins.column}
  width: ${({width = '100%'}) => width};
  ${getMarginBottom};
` as TAnyComponent<TFormFieldProps & JSX.IntrinsicElements['div']>;

export type TLabelProps = {
  disabled?: boolean;
};

export const Label = styled.label<TLabelProps>`
  display: inline-flex;
  align-items: center;
  margin-right: auto;
  ${({theme: {typography}}) => css`
    ${mixins.getFont(typography.label)}
    ${typography.labelWeight ? `font-weight: ${typography.labelWeight};` : ''}
  `}
`;

export const Header = styled.div`
  ${mixins.flexAlign('space-between', 'flex-start')}
  margin-bottom: ${({theme}) => theme.spacing.s2};
`;

export const FormAction = styled.button.attrs({
  type: 'button',
})`
  ${mixins.pureButton}
  color: ${({theme}) => theme.branding.content.primary};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    ${mixins.disabled}
    text-decoration: none;
  }
`;

type TFormTitleIconProps = {
  noMarginBottom?: boolean;
};

export const FormTitle = styled(H2)<TFormTitleIconProps>`
  ${mixins.flexAlign('flex-start', 'center')}
  margin: ${({theme, noMarginBottom}) => `0 0 ${noMarginBottom ? 0 : theme.spacing.s7} 0`};
`;

export const FormTitleIcon = styled.div`
  ${({theme}) => css`
    margin-right: ${theme.spacing.s2};
    color: ${theme.branding.content.tertiary};
  `}
`;

export const FormTitleHint = styled.div`
  ${mixins.f3}
  margin: ${({theme}) => `${theme.spacing.s3} 0 ${theme.spacing.s6}`};
`;

export const FormPaper = styled.form`
  ${mixins.paper}
  width: ${({theme}) => theme.dimensions.formWidth}px;
  margin: 84px auto 0;
`;
